export enum CraftLogoType {
  REGULAR = 'primary',
  TRANSPARENT = 'transparent',
}

export const CraftLogoSrcs: Record<CraftLogoType, `/${string}.png`> = {
  [CraftLogoType.REGULAR]: '/public-assets/logos/logo-crop.png',
  [CraftLogoType.TRANSPARENT]: '/public-assets/logos/logo-crop-full-transparent.png',
};
